import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Swal from 'sweetalert2'; // Import SweetAlert2
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2

import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import getDecryptData from '../../../helpers/getDecryptData';

const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components


function AllWithdrawal() {

   
        const decryptdatajson = getDecryptData();
    const UserId = decryptdatajson?._id;

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [employees, setEmployees] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchData = async () => {
    let MyUserId;
    if(decryptdatajson.type !== 0){
     MyUserId = UserId;
    }else{
     MyUserId = '';
    }
    
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/admin/all-Withdrawal?page=${currentPage}&limit=${limit}&search=${searchTerm}&userId=${MyUserId}`);
      setData(response.data.myData);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  // Function to handle delete
  const handleDelete = (categoryId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-danger', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {


        axiosInstance.delete(`/admin/delete-tax/${categoryId}`)
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Deleting Taxes Success!");
          })
          .catch((error) => {
            console.error('Error Taxes data:', error);
            toast.error("Error Taxes data");
          });
      }
    });
  };

  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1)
    setSearchTerm(e.target.value);


  };

  const handleSearch = () => {
    fetchData(currentPage);

  };


  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  }

  const downloadInvoice = async (id) => {
    try {
      const response = await toast.promise(
        axiosInstance.post(
          `/download-invoice`,

          { invoiceId: id },
          {
            responseType: "blob", // Important for handling binary data
          }
        ),
        {
          loading: "Invoice Downloading...", // Loading message
          success: "Invoice Downloaded!", // Success message
          error: "Failed to Invoice Download.", // Error message
        }
      );

      // Create a link element and simulate a click to download the file
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoice.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the invoice:", error);
    }
  };


const handleStatusChange = (statusId) => async (event) => {
  const newStatus = event.target.value;

  const { value: comment } = await MySwal.fire({
    title: "Add Comment",
    input: "textarea",
    inputLabel: "Reason for status update",
    inputPlaceholder: "Enter your comment here...",
    inputAttributes: {
      "aria-label": "Type your comment here"
    },
    showCancelButton: true
  });

  if (comment) {
    setLoading(true);
    try {
      await axiosInstance.put(`/admin/update-Withdrawal/${statusId}`, {
        status: newStatus,
        comment // send comment with status
      });
      toast.success("Status and comment updated successfully!");
      fetchData(currentPage);
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status.");
    } finally {
      setLoading(false);
    }
  } else {
    toast.error("Comment is required to update status.");
  }
};

  
    // Function to handle delete
  const handleWithdrawal = (userId) => {
    MySwal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this withdrawal!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, withdrawal it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      customClass: {
        popup: 'custom-swal-popup', // Add a class to the entire dialog
        confirmButton: 'btn-primary', // Add a class to the confirm button
      },
    }).then((result) => {
      if (result.isConfirmed) {
 
    axiosInstance.get(`/admin/withdrawal/${userId}`) 
          .then(() => {
            // Refresh the data or update the state after successful deletion
            fetchData();
            toast.success("Withdrawal Points Successfully!");
          })
          .catch((error) => {
            console.error('Error Mark Done:', error);
            toast.error(error.response.data.message || 'Error Withdrawal Points!');
          });
      }
    });
  };



  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">


          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4"> All Withdrawal</h1>
            </div>
            <div>
                {decryptdatajson.type !== 0  &&
             <button
                       
                             className="btn btn-primary d-inline-flex align-items-center me-2"
                                
                             onClick={() => handleWithdrawal(UserId)}
                           >
                             <i className="ri-cash-line me-2"></i>
                             withdraw Points
                           </button>
}
             
            </div>
          </div>
        </div>


        <div className="card">
          <div className="table-responsive py-4">

            {loading ? (
              <LoadingTable />
            ) : (
              <>


                <div className="datatable-top">
                  <div className="datatable-dropdown">
                    <label>
                      <select className="datatable-selector" value={limit} onChange={(e) => {
                        setlimit(parseInt(e.target.value, 10));
                        setCurrentPage(1); // Reset current page to 1 when the limit changes
                      }} >
                        <option value={5}>5</option>
                        <option value={10} >
                          10
                        </option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}

                      entries per page
                    </label>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search..." value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}> Search
                    </button>

                  </div>
                </div>





                <table className="table table-flush">
                  <thead>
                    <tr>
                      <th>Transaction No.</th>
                      <th> Date</th>
                      <th> Amount</th>
                      <th> Details</th>
                      <th>  Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && data.map((row, index) => (
                      <tr key={index}>
                        <td>{row.t_id ?? 'NA'}</td>
                        <td>{formatDate(row.createdAt)}</td>

<td>{Math.round(row.amount)}</td>
                        {/* <td>{row.type}</td> */}
                        <td>
                          <p>Full Name : {row?.userId?.username !== undefined ?
                            row?.userId?.username : 'Anonymous User'}
                            <br />
                            Phone No. :  {row?.userId?.phone !== undefined ?
                              row?.userId?.phone : 'Not Found'}
                          </p>
                        </td>

                        <td>
                          {decryptdatajson.type === 0 ?

                             <select
                                            className={`form-control select ${row.status === 0 ? 'bg-danger':'bg-success'} text-white`}
  style={{ width: "fit-content" }}
   value={row.status}
  name="status"
  onChange={handleStatusChange(row._id)}
>
  <option value="0">Pending</option>
  <option value="1">Accepted</option>
</select>  : 
<p className={`px-2 py-1 d-inline-block rounded ${row.status === 0 ? 'bg-danger':'bg-success'} text-white`} > 
{row.status === 0 ? 'Pending':'Accepted'}
</p>
                          }

{(row.note &&  row.note !== '' ) &&
<p className='small pt-1 mt-2 border-top d-inline-block fw-bold'>
                                 Note : <span className='text-success'>  {row.note}    </span> 
                                  </p>  
}
                                    
                        </td>








                      </tr>
                    ))}
                  </tbody>
                </table>


                <div className="datatable-bottom">
                  <div className="datatable-info">  </div>
                  <nav className="datatable-pagination">
                    <ul class="datatable-pagination-list">

                      <li className={`datatable-pagination-list-item ${currentPage === 1 ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="1" class="datatable-pagination-list-item-link" onClick={handlePreviousPage} disabled={loading || currentPage === 1}
                          aria-label="Page 1">‹</button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">Showing  Page{' '}
                          <strong>
                            Showing Page  {currentPage} of {totalPages}

                          </strong>{' '} </div>
                      </li>
                      <li className={`datatable-pagination-list-item ${currentPage === totalPages ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button data-page="2" class="datatable-pagination-list-item-link" aria-label="Page 2" onClick={handleNextPage} disabled={loading || currentPage === totalPages}
                        >  {loading ? 'Loading...' : '›'} </button>
                      </li>
                    </ul></nav>
                </div>



              </>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default AllWithdrawal;
